import { useState } from "react";

export interface FAQItem {
  question: string;
  answer: string;
}

export function FAQSection({ items, title = "Frequently Asked Questions" }: { items: FAQItem[]; title?: string }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section style={{ padding: "4rem 0 5rem", background: "var(--bg)" }}>
      <div className="container" style={{ maxWidth: "840px" }}>
        <h2
          style={{
            fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
            fontWeight: 800,
            textAlign: "center",
            marginBottom: "0.75rem",
            color: "var(--text-heading)",
            letterSpacing: "-0.02em",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            textAlign: "center",
            fontSize: "1rem",
            color: "var(--text-muted)",
            marginBottom: "2.5rem",
            maxWidth: "600px",
            margin: "0 auto 2.5rem",
          }}
        >
          Everything you need to know about Sentinel licensing and certification.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          {items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                style={{
                  border: "1px solid var(--border)",
                  borderRadius: "var(--radius-lg)",
                  overflow: "hidden",
                  background: "var(--card)",
                  transition: "box-shadow var(--transition-fast)",
                  boxShadow: isOpen ? "var(--shadow-md)" : "none",
                }}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  style={{
                    width: "100%",
                    padding: "1.125rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "1rem",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <span
                    style={{
                      fontSize: "0.9375rem",
                      fontWeight: 600,
                      color: "var(--text-heading)",
                      lineHeight: 1.4,
                    }}
                  >
                    {item.question}
                  </span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      flexShrink: 0,
                      color: "var(--text-muted)",
                      transition: "transform var(--transition-fast)",
                      transform: isOpen ? "rotate(180deg)" : "none",
                    }}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                <div
                  style={{
                    maxHeight: isOpen ? "500px" : "0",
                    overflow: "hidden",
                    transition: "max-height var(--transition)",
                  }}
                >
                  <p
                    style={{
                      padding: "0 1.5rem 1.25rem",
                      fontSize: "0.875rem",
                      lineHeight: 1.7,
                      color: "var(--text-body)",
                      margin: 0,
                    }}
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
